import React, { useState, Fragment, useEffect } from 'react';
import {
    AppBar,
    Box,
    Button,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    FormControl,
    Hidden,
    IconButton,
    MenuItem,
    Select,
    Toolbar,
    Typography,
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import { Auth } from 'aws-amplify';
import { host, SubscriptionInfo, BillingPlans } from "../../../data";
import { billing } from '../../../services/billing';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    preLoader: {
        display: 'block',
        margin: `${theme.spacing(3)}px auto`,
    },
    actionButtons: {
        marginRight: theme.spacing(2),
    },
    buttonProgress: {
        position: 'absolute',
        marginRight: 36,
    },
    table: {
        width: '100%',
        margin: '0 auto',
        maxWidth: '1200px',
        height: '55vh',
    },
}));

const ChangeDeviceStatus2 = ({ orgInfo, orgBilling, billingData, setBillingData, devices, setDevices }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [estNextInvoice, setEstNextInvoice] = useState("0.00");
    const [estCharge, setEstCharge] = useState("0.00");
    const [hasBillingInfo, setHasBillingInfo] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [openStatusChange, setOpenStatusChange] = useState(false);
    const [action, setAction] = useState('activate');
    const [open, setOpen] = useState(false);
    const [displayDevices, setDisplayDevices] = useState([]);
    const [checkedList, setCheckedList] = useState([]);
    const deviceColumns = [
        {
            headerName: t("device"),
            field: 'uid',
            width: 160,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("branch"),
            field: 'branchName',
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("site"),
            field: 'siteName',
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("tank"),
            field: 'tankName',
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("fluid"),
            field: 'fluidName',
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("type"),
            field: 'type',
            renderCell: renderType,
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("status"),
            field: 'status',
            renderCell: renderStatus,
            flex: 1,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
    ];

    const deviceColumnsMobile = [
        {
            headerName: t("device"),
            field: 'uid',
            width: 160,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("type"),
            field: 'type',
            renderCell: renderType,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("status"),
            field: 'status',
            renderCell: renderStatus,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
    ];

    function renderStatus(params) {
        var lstatus = "Disabled";
        var ldisabled = false;

        switch (params.row.status) {
            case 1:
                lstatus = t("active");
                break;
            case 2:
                lstatus = t("active");
                ldisabled = true;
                break;
            case 3:
                lstatus = t("inProcess");
            default:
                break;
        }
        return (<Typography variant="body2"> {lstatus} </Typography>);
    };
    function renderType(params) {
        return (
            <p>
                {params.value === "WiFi" ? t("wifi") : params.value === "PulseHUB" ? t("pulseProLevelMonitor") : params.value}
            </p>
        );
    };

    useEffect(() => {
        var i = 0;
        var l_devices = [];
        var test_status = 1;

        if (devices !== undefined) {
            if (action === 'activate') {
                test_status = 0;
            }
            for (i = 0; i < devices.length; i++) {
                if (devices[i].type === "cellular" || devices[i].type === 'pressure') {
                    if (devices[i].status === test_status) {
                        l_devices.push(devices[i]);
                    }
                }
            }
            for (i = 0; i < l_devices.length; i++) {
                if (l_devices[i].checked === undefined) {
                    l_devices[i].checked = false;
                }
            }
            setDisplayDevices(l_devices);
        }
    }, [devices, action]);

    function findSubscriptionPlanCode(subscriptionInfo) {
        var plan_code = BillingPlans[0].plan_code;
        for (var i = 0; i < BillingPlans.length; i++) {
            if (BillingPlans[i].label === subscriptionInfo) {
                plan_code = BillingPlans[i].plan_code;
                break;
            }
        }
        return plan_code;
    }

    const handleSetNewCharge = (value) => {
        var amount = Math.abs(value).toFixed(2).toString();
        setEstCharge(amount);
    };

    const handleNextInvoice = (value) => {
        var amount = value.toFixed(2).toString()
        setEstNextInvoice(amount);
    };

    const handleClickOpenActivate = () => {
        setOpenStatusChange(true);
        setAction("activate");
    };

    const handleClickOpenDisable = () => {
        setOpenStatusChange(true);
        setAction("deactivate");
    };

    const handleConfirmSelection = () => {
        setOpenStatusChange(false);
        if (checkedList.length > 0) {
            updatePreview();
            setOpen(true);
        }
    }

    const handleCloseStatusChange = () => {
        setIsLoading(false);
        setOpen(false);
        setOpenStatusChange(false);
        setCheckedList([]);
    };
    const handleStatusChange = () => {
        var quantity = 0;
        var i;

        setIsLoading(true);

        for (i = 0; i < devices.length; i++) {
            if (devices[i].status === 1) {
                quantity = quantity + 1;
            }
        }

        for (i = 0; i < checkedList.length; i++) {
            quantity = action === "activate" ? quantity + 1 : quantity - 1;
        }

        // update Subscription will update device status if no billing errors.
        updateSubscription(quantity);
    };

    const updateDeviceStatus = () => {
        var code = "";
        var targetList = [];
        var l_action = action;

        if (checkedList.length > 2) {
            l_action = 'Q_' + action; //Set up to be a queued/batched transaction
        }

        for (var i = 0; i < checkedList.length; i++) {
            targetList.push({ 'uid': checkedList[i], 'code': code, 'action': l_action });
        }

        console.log("Update Device Status");

        Auth.currentAuthenticatedUser()
            .then(data => {
                var body = JSON.stringify({
                    'devices': targetList, 'sync': 0,
                    'hasBillingInfo': hasBillingInfo
                });

                var requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                    body: body
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/devices/', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error === "OK") {
                            //Update and Create Subscription
                            setDevices(data.deviceList);
                        } else {
                            if (data.error === "error" && data.errorList.length > 0) {
                                alert(data.errorList[0].error);
                            }
                            else {
                                alert(data.error)
                            }
                        }
                        handleCloseStatusChange();
                    }).catch((error) => {
                        handleCloseStatusChange();
                        console.log(error)
                    })
            });
    }

    const updateSubscription = async (input_quantity) => {
        var msg = { status: 0, data: {} };
        var quantity = input_quantity;

        try {
            if (billingData.subscriptions.length == 0 && action !== "activate") {
                throw new Error("No subscription to delete");
            }
            else if (billingData.subscriptions.length == 0 && action === "activate") {
                console.log("New Subscription");

                const plan_code = findSubscriptionPlanCode(orgBilling.billing_plan);
                msg = await billing.newSubscription(
                    orgInfo.orgId,
                    plan_code,
                    orgBilling.billing_curr,
                    quantity,
                    SubscriptionInfo.total_billing_cycles);
            }
            else {
                console.log("Update Subscription");

                var sub = [{}];
                sub[0].quantity = quantity;
                sub[0].id = billingData.subscriptions[0].id;
                msg = await billing.updateSubscriptions(
                    orgInfo.orgId,
                    sub
                );
            }

            const { error, billing_account } = msg.data;

            if (msg.status === 404) {
                console.log(msg.status);
            }

            if (error !== 'OK' && msg.status !== 200) {
                if(error.includes("submitted values match the current subscriptions")){
                    //Still update the device status if the subscription value is correct.
                    updateDeviceStatus();
                    throw new Error(error);
                }
                else{
                    alert(error);
                    throw new Error(error);
                }
            }

            setBillingData(billing_account);
            updateDeviceStatus();
        } catch (error) {
            console.error(error);
            //handleCloseStatusChange();
            //No longer prevent activation for billing errors.  Improve customer experience
            updateDeviceStatus();
        }
    };

    const updatePreview = () => {
        var newCharge = 0
        var nextInvoice = 0;
        var newQty = 0;
        var currentlyActive = 0;
        var l_billingPlan = BillingPlans[0];
        var i = 0;

        for (i = 0; i < BillingPlans.length; i++) {
            if (BillingPlans[i].label === orgBilling.billing_plan) {
                l_billingPlan = BillingPlans[i];
                break;
            }
        }

        newQty = checkedList.length;

        for (i = 0; i < devices.length; i++) {
            if (devices[i].status === 1) {
                currentlyActive = currentlyActive + 1;
            }
        }

        if (billingData.subscriptions.length == 0) {
            newCharge = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * newQty * 100) / 100;
            nextInvoice = newCharge;
            if (billingData.subscriptions.length > 0) {
                nextInvoice = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * (currentlyActive + newQty) * 100) / 100;
            }
            handleSetNewCharge(newCharge);
        } else {
            if (action === "deactivate") {
                newQty = newQty * -1;
            }
            previewSubscription();
            nextInvoice = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * (currentlyActive + newQty) * 100) / 100;
        }

        handleNextInvoice(nextInvoice);
    };

    const previewSubscription = async () => {
        var msg = { status: 0, data: {} };
        var newQty = 0;
        var currentlyActive = 0;
        var i = 0;

        try {
            if (billingData.subscriptions.length == 0) {
                console.log("No Subscription, cannot preview");
            } else {
                newQty = checkedList.length;
                for (i = 0; i < devices.length; i++) {
                    if (devices[i].status === 1) {
                        currentlyActive = currentlyActive + 1;
                    }
                }

                console.log("Update Subscription");

                var sub = [{}];

                if (action === "activate") {
                    sub[0].quantity = currentlyActive + newQty;
                } else {
                    sub[0].quantity = currentlyActive - newQty;
                }

                sub[0].id = billingData.subscriptions[0].id;
                //console.log(sub);
                msg = await billing.previewSubscription(
                    orgInfo.orgId,
                    sub
                );
            }

            //console.log(msg.data);

            const { error, billing_preview } = msg.data;

            if (msg.status === 404) {
                console.log(msg.status);
            }

            if (error !== 'OK' && msg.status !== 200) {
                throw new Error(error);
            }

            handleSetNewCharge(billing_preview[0].estimated_total);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Fragment>
            <Button className={classes.actionButtons} variant="outlined" color="primary" onClick={handleClickOpenDisable}>
                {t("disableDevices_caps")}
            </Button>
            <Button className={classes.actionButtons} variant="contained" color="secondary" onClick={handleClickOpenActivate}>
                {t("activateDevices_caps")}
            </Button>
            {<Dialog fullWidth={true} maxWidth="lg" open={openStatusChange} onClose={handleCloseStatusChange} >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            {action === "activate" ? t("activateDevices_caps") : t("disableDevices_caps")}
                        </Typography>
                        <IconButton edge="start" color="inherit" onClick={handleCloseStatusChange} aria-label={t("close")}>
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className={classes.content} />
                    <Hidden smDown>
                        <div className={classes.table}>
                            <DataGrid hideFooterSelectedRowCount
                                rowsPerPageOptions={[25, 50, 100]}
                                pagination
                                checkboxSelection
                                onSelectionModelChange={(e) => {
                                    const selectedIDs = (e.selectionModel);
                                    setCheckedList(selectedIDs);
                                }}
                                pageSize={100}
                                rows={displayDevices}
                                columns={deviceColumns} />
                        </div>
                    </Hidden>
                    <Hidden mdUp>
                        <div className={classes.table}>
                            <DataGrid hideFooterSelectedRowCount
                                rowsPerPageOptions={[25, 50, 100]}
                                pagination
                                checkboxSelection
                                onSelectionModelChange={(e) => {
                                    const selectedIDs = (e.selectionModel);
                                    setCheckedList(selectedIDs);
                                }}
                                pageSize={100}
                                rows={displayDevices}
                                columns={deviceColumnsMobile} />
                        </div>
                    </Hidden>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseStatusChange} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button variant="contained" onClick={handleConfirmSelection} color="primary" disabled={isLoading}>
                        {t("confirm")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {open && <Dialog disableBackdropClick disableEscapeKeyDown open={open} onClose={handleCloseStatusChange}>
                <DialogTitle>Change Device Status</DialogTitle>
                <DialogContent className={classes.root}>
                    {<Typography variant="body2" gutterBottom>
                        {action === "activate" ? t("areYouSureYouWantToActivate") : t("areYouSureYouWantToDisable")}
                    </Typography>}
                    <form noValidate>
                        <FormControl>
                            <Select
                                className={classes.listItemText}
                                value={checkedList[0]}
                            >
                                {checkedList.map((dev) => (
                                    <MenuItem
                                        value={dev}
                                        key={dev}
                                    >
                                        {dev}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </form>
                    <div className={classes.content} />
                    {<Typography variant="body2" gutterBottom >
                        <Box fontWeight="fontWeightBold" m={0}>
                            {action === "activate" ? t("estimatedTotalDueNow") : t("estimatedCredit")}: {estCharge} {orgBilling.billing_curr}
                        </Box>
                    </Typography>}
                    {<Typography variant="body2" gutterBottom >
                        <Box fontWeight="fontWeightBold" m={0}>
                            {t("estimatedTotaleDueNext",{billing_plan: t(orgBilling.billing_plan)})} {estNextInvoice} {orgBilling.billing_curr}
                        </Box>
                    </Typography>}
                    {<Typography variant="body2" gutterBottom >
                        {t("additonalTaxesFeesCredits")}
                    </Typography>}
                    {<div className={classes.content} />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseStatusChange} color="primary">
                        {t("cancel")}
                    </Button>
                    {<Button variant="contained" onClick={handleStatusChange} color="primary" disabled={isLoading}>
                        {t("confirm")}
                    </Button>}
                    {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </DialogActions>
            </Dialog>}
        </Fragment>
    );
};

export default ChangeDeviceStatus2;